import { Button } from 'components/Global/Button'

export const AnchorLinks = ({ links }) => {
  return (
    <div className="flex items-center justify-center p-20">
      <div className="flex gap-4 rounded-10 bg-whiter p-4">
        {links.map((link) => {
          return (
            <Button
              as="link"
              scroll={false}
              href={`#${link.anchor}`}
              key={link._key}
              className="py-8 hover:!bg-[#F0F0F0]"
            >
              {link.label}
            </Button>
          )
        })}
      </div>
    </div>
  )
}
